import React from "react";

import PropTypes from "prop-types";

import InlineLoader from "../../components/InlineLoader";

function PageDataLoader({ isLoading, absolute = false, children }) {
  return isLoading ? (
    <div
      className={`${
        absolute ? "absolute top-0 bottom-0 left-0 right-0" : "w-full h-full"
      } flex items-center justify-center`}
    >
      <InlineLoader />
    </div>
  ) : children ? (
    children
  ) : null;
}

PageDataLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadingError: PropTypes.object,
  loadData: PropTypes.func,
  loadingText: PropTypes.string,
  children: PropTypes.node,
};

export default PageDataLoader;
